import React, { useEffect, useMemo, useState } from "react";
import '../../../node_modules/bootstrap/dist/css/bootstrap.min.css';
import TableContainer from '../../components/Common/TableContainer';
import * as Yup from "yup";
import { useFormik } from "formik";

//import components
import Breadcrumbs from '../../components/Common/Breadcrumb';
import DeleteModal from '../../components/Common/DeleteModal';

import {
    getTeachers as onGetTeachers,
    addNewTeacher as onAddNewTeacher,
    updateTeacher as onUpdateTeacher,
    deleteTeacher as onDeleteTeacher,
} from "store/actions";

//redux
import { useSelector, useDispatch } from "react-redux";
import { createSelector } from "reselect";

import {
    Col,
    Row,
    UncontrolledTooltip,
    Modal,
    ModalHeader,
    ModalBody,
    Form,
    Input,
    FormFeedback,
    Label,
    Card,
    CardBody,
    UncontrolledDropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
    Badge,
    Button,
} from "reactstrap";
import Spinners from "components/Common/Spinner";
import { ToastContainer } from "react-toastify";
import { Link } from "react-router-dom";

const Teacher = () => {

    //meta title
    document.title = "Enseignants | CinzanEdu";

    const [modal, setModal] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [teacher, setTeacher] = useState(null);
    


 

    // validation
    const validation = useFormik({
        // enableReinitialize : use this flag when initial values needs to be changed
        enableReinitialize: true,

        initialValues: {
            uid: (teacher && teacher.uid) || '',
            first_name: (teacher && teacher.first_name) || '',
            last_name: (teacher && teacher.last_name) || '',
            gender: (teacher && teacher.gender) || '',
            matricule: (teacher && teacher.matricule) || '',
            phone: (teacher && teacher.phone) || '',
            email: (teacher && teacher.email) || '',
            grade: (teacher && teacher.grade) || '',
            speciality: (teacher && teacher.speciality) || '',
            
            
        },
        validationSchema: Yup.object({

            first_name: Yup.string().required("Veuillez saisir le prénom"),
            last_name: Yup.string().required("Veuillez saisir le nom"),
            gender: Yup.string().required("Veuillez saisir la civilité"),
            matricule: Yup.string().required("Veuillez saisir le matricule"),
            phone: Yup.string().required("Veuillez saisir le téléphone"),
            grade: Yup.string().required("Veuillez saisir la grade"),
            speciality: Yup.string().required("Veuillez saisir la spécialité"),
            

        }),
        onSubmit: (values) => {
            if (isEdit) {
                //const payload = { series_category: values }
                const updateTeacher = {
                    id: values.id,
                    uid: values.uid,
                    first_name: values.first_name,
                    last_name: values.last_name,
                    gender: values.gender,
                    matricule: values.matricule,
                    phone: values.phone,
                    email: values.email,
                    grade: values.grade,
                    
                    
                };
                // update movie category
                dispatch(onUpdateTeacher(updateTeacher));
                validation.resetForm();
            } else {
                const newTeacher = {
                    //id: values["id"],
                    //uid: values["uid"],
                    first_name: values["first_name"],
                    last_name: values["last_name"],
                    gender: values["gender"],
                    matricule: values["matricule"],
                    phone: values["phone"],
                    email: values["email"],
                    grade: values["grade"],
                    speciality: values["speciality"],

                };
                // save new movie category
                dispatch(onAddNewTeacher(newTeacher));
                validation.resetForm();
            }
            toggle();
        },
    });

    const dispatch = useDispatch();

    const TeacherProperties = createSelector(
        (state) => state.teacherReducer, // C’est une fonction qui prend tout le state Redux et renvoie seulement la partie SerialMovieReducer
        (teacherReducer) => ({
            teachers: teacherReducer.teachers,
            loading: teacherReducer.loading
        })
    );

    const {teachers, loading} = useSelector(TeacherProperties);

    const [isLoading, setLoading] = useState(loading)

    useEffect(() => {
        if (teachers && !teachers.length) {
            dispatch(onGetTeachers());
        }
    }, [dispatch, teachers]);

    const toggle = () => {
        if (modal) {
            setModal(false);
            setTeacher(null);
        } else {
            setModal(true);
        }
    };

    const handleTeacherClick = arg => {
        const phone = arg;
        setTeacher({
            id: teacher.id,
            uid: teacher.uid,
            first_name: teacher.first_name,
            last_name: teacher.last_name,
            gender: teacher.gender,
            matricule: teacher.matricule,
            phone: teacher.phone,
            
           
        });


        // Set for update url
        setIsEdit(true);

        toggle();
    };

    //delete Serial movie
    const [deleteModal, setDeleteModal] = useState(false);

    const onClickDelete = (branch) => {
        setTeacher(branch);
        setDeleteModal(true);
    };

    const handleDeleteTeacher = () => {
        if (teacher && teacher.id) {
            
            dispatch(onDeleteTeacher(teacher));
            setDeleteModal(false);
        }
    };

    const onClickNewTeacher = () => {
        setIsEdit(false);
        setTeacher(null);
        toggle();
        //setModal(true)
    };

    const columns = useMemo(
        () => [
            {
                header: 'ID',
                accessorKey: "id",
                enableColumnFilter: false,
                enableSorting: true,
                cell: (cellProps) => {
                    return <Link to="#" className="text-body fw-bold">{cellProps.row.original.id}</Link>
                }
            },
            {
                header: "Matricule",
                accessorKey: "matricule",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Prénom",
                accessorKey: "first_name",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Nom",
                accessorKey: "last_name",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Civilité",
                accessorKey: "gender",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Téléphone",
                accessorKey: "phone",
                enableColumnFilter: false,
                enableSorting: true,
            },
            
            
            
            {
                header: 'Action',
                enableColumnFilter: false,
                enableSorting: true,
                cell: (cellProps) => {
                    return (
                        <ul className="list-unstyled hstack gap-1 mb-0">
                            
                            <li>
                                <Link
                                    to="#"
                                    className="btn btn-sm btn-soft-info"
                                    onClick={() => {
                                        const jobData = cellProps.row.original;
                                        handleTeacherClick(jobData);
                                    }}
                                    id={`edittooltip-${cellProps.row.original.id}`}
                                >
                                    <i className="mdi mdi-pencil-outline" />
                                    <UncontrolledTooltip placement="top" target={`edittooltip-${cellProps.row.original.id}`} >
                                        Edit
                                    </UncontrolledTooltip>
                                </Link>
                            </li>

                            <li>
                                <Link
                                    to="#"
                                    className="btn btn-sm btn-soft-danger"
                                    onClick={() => {
                                        const jobData = cellProps.row.original;
                                        //console.log("ON DELETE: ", jobData);
                                        onClickDelete(jobData);
                                    }}
                                    id={`deletetooltip-${cellProps.row.original.id}`}
                                >
                                    <i className="mdi mdi-delete-outline" />
                                    <UncontrolledTooltip placement="top" target={`deletetooltip-${cellProps.row.original.id}`}>
                                        Delete
                                    </UncontrolledTooltip>
                                </Link>
                            </li>
                        </ul>
                    );
                }
            },
        ],
        []
    );

    return (
        <React.Fragment>
            <DeleteModal
                show={deleteModal}
                onDeleteClick={handleDeleteTeacher}
                onCloseClick={() => setDeleteModal(false)}
            />
            <div className="page-content">
                <div className="container-fluid">
                    <Breadcrumbs title="Enseignants" breadcrumbItem="Liste des enseignants" />
                    {
                        isLoading ? <Spinners setLoading={setLoading} />
                            :
                            <Row>
                                <Col lg="12">
                                    <Card>
                                        <CardBody className="border-bottom">
                                            <div className="d-flex align-items-center">
                                                <h5 className="mb-0 card-title flex-grow-1"></h5> 
                                                <div className="flex-shrink-0">
                                                    <Link to="#!" onClick={onClickNewTeacher} className="btn btn-primary me-1">Ajouter un enseignant</Link>
                                                    
                                                </div>
                                            </div>
                                        </CardBody>
                                        <CardBody>
                                            <TableContainer
                                                columns={columns}
                                                data={teachers || []}
                                                isCustomPageSize={true}
                                                isGlobalFilter={true}
                                                //isJobListGlobalFilter={false}
                                                isPagination={true}
                                                SearchPlaceholder="Rechercher ..."
                                                tableClass="align-middle table-nowrap dt-responsive nowrap w-100 table-check dataTable no-footer dtr-inline"
                                                theadClass="table-light"
                      
                        
                                                
                                                //tableClass="align-middle table-nowrap dt-responsive nowrap w-100 table-check dataTable no-footer dtr-inline mt-4 border-top"
                                                pagination="pagination"
                                                paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
                                            />
                                        </CardBody>
                                    </Card>
                                </Col>
                            </Row>
                    }
                    <Modal 
                        isOpen={modal} 
                        toggle={toggle}
                         backdrop={'static'}
                            id="staticBackdrop"
                    >
                        <ModalHeader toggle={toggle} tag="h4">
                            {!!isEdit ? "Modifier - Enseignant" : "Ajouter - Enseignant"}
                        </ModalHeader>
                        <ModalBody>
                            <Form
                                onSubmit={(e) => {
                                    e.preventDefault();
                                    validation.handleSubmit();
                                    return false;
                                }}
                            >
                                <Row>
                                    <Col className="col-12">
                                        
                                        <div className="mb-3">
                                            <Label>Prénom</Label>
                                            <Input
                                                name="first_name"
                                                type="text"
                                                placeholder="Prénom"
                                                validate={{
                                                    required: { value: true },
                                                }}
                                                onChange={validation.handleChange}
                                                onBlur={validation.handleBlur}
                                                value={validation.values.first_name || ""}
                                                invalid={
                                                    validation.touched.first_name && validation.errors.first_name ? true : false
                                                }
                                            />
                                            {validation.touched.first_name && validation.errors.first_name ? (
                                                <FormFeedback type="invalid">{validation.errors.first_name}</FormFeedback>
                                            ) : null}
                                        </div>

                                        <div className="mb-3">
                                            <Label>Nom</Label>
                                            <Input
                                                name="last_name"
                                                type="text"
                                                placeholder="Nom"
                                                validate={{
                                                    required: { value: true },
                                                }}
                                                onChange={validation.handleChange}
                                                onBlur={validation.handleBlur}
                                                value={validation.values.last_name || ""}
                                                invalid={
                                                    validation.touched.last_name && validation.errors.last_name ? true : false
                                                }
                                            />
                                            {validation.touched.last_name && validation.errors.last_name ? (
                                                <FormFeedback type="invalid">{validation.errors.last_name}</FormFeedback>
                                            ) : null}
                                        </div>

                                        <div className="mb-3">
                                            <Label>Civilité</Label>
                                            <Input
                                                name="gender"
                                                type="select"
                                                value={validation.values.gender || ""}
                                                validate={{
                                                    required: { value: true },
                                                }}
                                                onChange={validation.handleChange}
                                                onBlur={validation.handleBlur}
                                                invalid={
                                                    validation.touched.gender && validation.errors.gender ? true : false
                                                }
                                                >
                                                <option value="">Sélectionner</option>
                                                <option value="M.">M.</option>
                                                <option value="Mme">Mme</option>
                                                <option value="Mlle">Mlle</option>
                                            </Input>
                                            {validation.touched.phone && validation.errors.phone ? (
                                                <FormFeedback type="invalid">{validation.errors.phone}</FormFeedback>
                                            ) : null}
                                        </div>         

                                        <div className="mb-3">
                                            <Label>Matricule</Label>
                                            <Input
                                                name="matricule"
                                                type="text"
                                                placeholder="Matricule"
                                                validate={{
                                                    required: { value: true },
                                                }}
                                                onChange={validation.handleChange}
                                                onBlur={validation.handleBlur}
                                                value={validation.values.matricule || ""}
                                                invalid={
                                                    validation.touched.matricule && validation.errors.matricule ? true : false
                                                }
                                            />
                                            {validation.touched.matricule && validation.errors.matricule ? (
                                                <FormFeedback type="invalid">{validation.errors.matricule}</FormFeedback>
                                            ) : null}
                                        </div>

                                         <div className="mb-3">
                                            <Label>Spécialité</Label>
                                            <Input
                                                name="speciality"
                                                type="text"
                                                placeholder="Spécialité"
                                                validate={{
                                                    required: { value: true },
                                                }}
                                                onChange={validation.handleChange}
                                                onBlur={validation.handleBlur}
                                                value={validation.values.speciality || ""}
                                                invalid={
                                                    validation.touched.speciality && validation.errors.speciality ? true : false
                                                }
                                            />
                                            {validation.touched.speciality && validation.errors.spectiality ? (
                                                <FormFeedback type="invalid">{validation.errors.speciality}</FormFeedback>
                                            ) : null}
                                        </div>

                                         <div className="mb-3">
                                            <Label>Grade</Label>
                                            <Input
                                                name="grade"
                                                type="text"
                                                placeholder="Grade"
                                                validate={{
                                                    required: { value: true },
                                                }}
                                                onChange={validation.handleChange}
                                                onBlur={validation.handleBlur}
                                                value={validation.values.grade || ""}
                                                invalid={
                                                    validation.touched.grade && validation.errors.grade ? true : false
                                                }
                                            />
                                            {validation.touched.grade && validation.errors.grade ? (
                                                <FormFeedback type="invalid">{validation.errors.grade}</FormFeedback>
                                            ) : null}
                                        </div>

                                        <div className="mb-3">
                                            <Label>Téléphone</Label>
                                            <Input
                                                name="phone"
                                                type="text"
                                                placeholder="Téléphone"
                                                validate={{
                                                    required: { value: true },
                                                }}
                                                onChange={validation.handleChange}
                                                onBlur={validation.handleBlur}
                                                value={validation.values.phone || ""}
                                                invalid={
                                                    validation.touched.phone && validation.errors.phone ? true : false
                                                }
                                            />
                                            {validation.touched.phone && validation.errors.phone ? (
                                                <FormFeedback type="invalid">{validation.errors.phone}</FormFeedback>
                                            ) : null}
                                        </div>

                                        <div className="mb-3">
                                            <Label>Email</Label>
                                            <Input
                                                name="email"
                                                type="email"
                                                placeholder="Email"
                                                validate={{
                                                    required: { value: true },
                                                }}
                                                onChange={validation.handleChange}
                                                onBlur={validation.handleBlur}
                                                value={validation.values.email || ""}
                                                invalid={
                                                    validation.touched.email && validation.errors.email ? true : false
                                                }
                                            />
                                            {validation.touched.email && validation.errors.email ? (
                                                <FormFeedback type="invalid">{validation.errors.email}</FormFeedback>
                                            ) : null}
                                        </div>

                                        
                                       
                                       
                                        
                                       

                                        

                                        
                                        
                                        
                                        
                                        
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <div className="text-end">
                                            <Button color="btn btn-primary me-1"
                                                type="submit"
                                                className="save-user"
                                            >
                                                
                                                {!!isEdit ? "Modifier " : "Enregistrer"}
                                            </Button>
                                        </div>
                                    </Col>
                                </Row>
                            </Form>
                        </ModalBody>
                    </Modal>
                </div>
            </div>
            <ToastContainer />
        </React.Fragment>
    );
}


export default Teacher;